const InfiniteScroll = require('infinite-scroll');
var cards = {
	init: function() {
		document.querySelectorAll('.card').forEach(function(card) {
			cards.addListeners(card);
		});
	},

	toggleQuestions: function(toggle) {
		document.querySelectorAll('.card').forEach(function(card) {
			cards.toggleCard(card, toggle);
		})
	},

	toggleCard: function(card, toggle) {
		const toggled = card.getAttribute('data-toggled');
		if (toggled == "true") {
			if (toggle == 'title') {
				card.querySelector('.card--toggle').click();
			}
		} else {
			if (toggle == 'question') {
				card.querySelector('.card--toggle').click();
			}
		}
	},

	addListeners: function(card) {
		//Handle card hover
		card.addEventListener('mouseover', function() {
			cards.cardOver(this);
		});
		card.addEventListener('mouseleave', function() {
			cards.cardLeave(this);
		});

		// Handle card header toggle click
		const question = card.querySelector('.card--toggle');
		if (question) {
			question.addEventListener('click', function() {
				cards.cardClick(card);
			});
		}
	},

	cardOver: function(card) {
		const bg = card.querySelector('.card--toggle__background'),
				ch = card.querySelector('.card--hover');
		ch.classList.remove('is-disabled');
		bg.classList.remove('none');
		bg.classList.add(bg.getAttribute('data-contenttype'));
		bg.classList.add('hover');
	},

	cardLeave: function(card) {
		const bg = card.querySelector('.card--toggle__background'),
				ch = card.querySelector('.card--hover');
		ch.classList.add('is-disabled');
		bg.classList.remove(bg.getAttribute('data-contenttype'));
		bg.classList.add('none');
	},

	cardClick: function(card) {
		const cq = card.querySelector('.card--question'),
				ct = card.querySelector('.card--toggle'),
				toggled = card.getAttribute('data-toggled');

		if (toggled === "false") {
			cq.classList.add('on');
			ct.classList.add('on');
			ct.classList.add('card--toggle__close');
			ct.classList.remove('card--toggle__open');
			card.setAttribute('data-toggled', true);
		} else {
			cq.classList.remove('on');
			ct.classList.remove('on');
			ct.classList.add('card--toggle__open');
			ct.classList.remove('card--toggle__close');
			card.setAttribute('data-toggled', false);
		}
	}
}

// make it do some stuff
document.addEventListener("DOMContentLoaded", () => {
	// toggle between questions and teasers
	document.querySelectorAll('.filter').forEach(function(filter) {
		filter.addEventListener('click', function() {
			document.querySelector('.filter.active').classList.remove('active');
			this.classList.add('active');
			cards.toggleQuestions(this.getAttribute('data-filter'));
		});
	});

	//init all the cards on the page on initial load
	if (document.querySelector('.card')) {
		cards.init();
	}

	// Set up pagination for infinite scrolling
	// if (document.querySelector('.results')) {
	if (document.querySelector('.results') && document.querySelector('.page__next')) {
		var infScroll = new InfiniteScroll( '.results--container', {
			// options
			debug: true,
			path: '.page__next',
			append: '.data',
			history: true,
			hideNav: '.page-nav',
			button: '.page-more',
		});

		infScroll.on( 'append', function(response, path, items) {//loops through the new cards and add event listeners for them
			const activeFilter = document.querySelector('.filter.active');
			const toggleBy = (activeFilter) ? activeFilter.getAttribute('data-filter') : 'title';//need to apply the correct toggle
			items.forEach(function(card) {
				// card.classList.add('animate__animated', 'animate__fadeIn');
				cards.addListeners(card);
				cards.toggleCard(card, toggleBy);
			});
			
		});
	}
});